// Portado da Central do Perito (`src/data/tribunais.ts`, commit f5c1923) em 03/11, só com os imports trocados e um parâmetro sem uso marcado (000385).
// Tribunais brasileiros — base estática embutida (sem fetch)
// TRTs (24 regiões com varas principais), TJs (capitais), TRFs (6 regiões)
export interface Tribunal {
  sigla: string;
  nome: string;
  tipo: "TRT" | "TJ" | "TRF" | "STJ" | "STF" | "Outro";
  uf?: string;
  // código CNJ (J.TR) — usado para detecção automática a partir do número
  codigoCnj?: { j: string; tr: string };
  varas: string[];
  cidades?: string[];
}

// O `_ufs` é de lá e não é lido (o hub roda o `tsc` com noUnusedParameters): o sublinhado o declara assim.
const trtVaras = (regiao: number, _ufs: string[]): string[] => {
  const base = Array.from({ length: 12 }, (_, i) => `${i + 1}ª Vara do Trabalho`);
  return [...base, `Vara do Trabalho Itinerante`, `TRT da ${regiao}ª Região - Pleno`];
};

// Ordem oficial do CNJ para os Tribunais de Justiça (código TR = posição + 1)
const UFS_CNJ = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SE",
  "SP",
  "TO",
];

// Varas em que o perito contábil costuma ser nomeado
const VARAS_ESTADUAIS = [
  "Vara Cível",
  "Vara de Família",
  "Vara de Sucessões",
  "Vara da Fazenda Pública",
  "Vara Empresarial",
  "Vara de Falências e Recuperações Judiciais",
  "Vara de Execuções Fiscais",
];

const VARAS_FEDERAIS = [
  "Vara Federal Cível",
  "Vara Federal de Execução Fiscal",
  "Vara Federal Previdenciária",
];

export const TRIBUNAIS: Tribunal[] = [
  // TRTs
  {
    sigla: "TRT-1",
    nome: "TRT 1ª Região",
    tipo: "TRT",
    uf: "RJ",
    codigoCnj: { j: "5", tr: "01" },
    varas: trtVaras(1, ["RJ"]),
    cidades: ["Rio de Janeiro", "Niterói", "Nova Iguaçu"],
  },
  {
    sigla: "TRT-2",
    nome: "TRT 2ª Região",
    tipo: "TRT",
    uf: "SP",
    codigoCnj: { j: "5", tr: "02" },
    varas: trtVaras(2, ["SP"]),
    cidades: ["São Paulo", "Guarulhos", "Santo André", "Osasco", "Santos"],
  },
  {
    sigla: "TRT-3",
    nome: "TRT 3ª Região",
    tipo: "TRT",
    uf: "MG",
    codigoCnj: { j: "5", tr: "03" },
    varas: trtVaras(3, ["MG"]),
    cidades: ["Belo Horizonte", "Contagem", "Betim", "Uberlândia"],
  },
  {
    sigla: "TRT-4",
    nome: "TRT 4ª Região",
    tipo: "TRT",
    uf: "RS",
    codigoCnj: { j: "5", tr: "04" },
    varas: trtVaras(4, ["RS"]),
    cidades: ["Porto Alegre", "Caxias do Sul", "Canoas", "Pelotas"],
  },
  {
    sigla: "TRT-5",
    nome: "TRT 5ª Região",
    tipo: "TRT",
    uf: "BA",
    codigoCnj: { j: "5", tr: "05" },
    varas: trtVaras(5, ["BA"]),
    cidades: ["Salvador", "Feira de Santana", "Itabuna"],
  },
  {
    sigla: "TRT-6",
    nome: "TRT 6ª Região",
    tipo: "TRT",
    uf: "PE",
    codigoCnj: { j: "5", tr: "06" },
    varas: trtVaras(6, ["PE"]),
    cidades: ["Recife", "Olinda", "Jaboatão", "Caruaru"],
  },
  {
    sigla: "TRT-7",
    nome: "TRT 7ª Região",
    tipo: "TRT",
    uf: "CE",
    codigoCnj: { j: "5", tr: "07" },
    varas: trtVaras(7, ["CE"]),
    cidades: ["Fortaleza", "Caucaia", "Sobral"],
  },
  {
    sigla: "TRT-8",
    nome: "TRT 8ª Região",
    tipo: "TRT",
    uf: "PA",
    codigoCnj: { j: "5", tr: "08" },
    varas: trtVaras(8, ["PA", "AP"]),
    cidades: ["Belém", "Macapá", "Marabá"],
  },
  {
    sigla: "TRT-9",
    nome: "TRT 9ª Região",
    tipo: "TRT",
    uf: "PR",
    codigoCnj: { j: "5", tr: "09" },
    varas: trtVaras(9, ["PR"]),
    cidades: ["Curitiba", "Londrina", "Maringá", "Cascavel"],
  },
  {
    sigla: "TRT-10",
    nome: "TRT 10ª Região",
    tipo: "TRT",
    uf: "DF",
    codigoCnj: { j: "5", tr: "10" },
    varas: trtVaras(10, ["DF", "TO"]),
    cidades: ["Brasília", "Palmas", "Taguatinga"],
  },
  {
    sigla: "TRT-11",
    nome: "TRT 11ª Região",
    tipo: "TRT",
    uf: "AM",
    codigoCnj: { j: "5", tr: "11" },
    varas: trtVaras(11, ["AM", "RR"]),
    cidades: ["Manaus", "Boa Vista"],
  },
  {
    sigla: "TRT-12",
    nome: "TRT 12ª Região",
    tipo: "TRT",
    uf: "SC",
    codigoCnj: { j: "5", tr: "12" },
    varas: trtVaras(12, ["SC"]),
    cidades: ["Florianópolis", "Joinville", "Blumenau", "Chapecó"],
  },
  {
    sigla: "TRT-13",
    nome: "TRT 13ª Região",
    tipo: "TRT",
    uf: "PB",
    codigoCnj: { j: "5", tr: "13" },
    varas: trtVaras(13, ["PB"]),
    cidades: ["João Pessoa", "Campina Grande"],
  },
  {
    sigla: "TRT-14",
    nome: "TRT 14ª Região",
    tipo: "TRT",
    uf: "RO",
    codigoCnj: { j: "5", tr: "14" },
    varas: trtVaras(14, ["RO", "AC"]),
    cidades: ["Porto Velho", "Rio Branco"],
  },
  {
    sigla: "TRT-15",
    nome: "TRT 15ª Região",
    tipo: "TRT",
    uf: "SP",
    codigoCnj: { j: "5", tr: "15" },
    varas: trtVaras(15, ["SP"]),
    cidades: [
      "Campinas",
      "Ribeirão Preto",
      "Sorocaba",
      "São José dos Campos",
      "Bauru",
      "Piracicaba",
    ],
  },
  {
    sigla: "TRT-16",
    nome: "TRT 16ª Região",
    tipo: "TRT",
    uf: "MA",
    codigoCnj: { j: "5", tr: "16" },
    varas: trtVaras(16, ["MA"]),
    cidades: ["São Luís", "Imperatriz"],
  },
  {
    sigla: "TRT-17",
    nome: "TRT 17ª Região",
    tipo: "TRT",
    uf: "ES",
    codigoCnj: { j: "5", tr: "17" },
    varas: trtVaras(17, ["ES"]),
    cidades: ["Vitória", "Vila Velha", "Cariacica"],
  },
  {
    sigla: "TRT-18",
    nome: "TRT 18ª Região",
    tipo: "TRT",
    uf: "GO",
    codigoCnj: { j: "5", tr: "18" },
    varas: trtVaras(18, ["GO"]),
    cidades: ["Goiânia", "Anápolis", "Aparecida"],
  },
  {
    sigla: "TRT-19",
    nome: "TRT 19ª Região",
    tipo: "TRT",
    uf: "AL",
    codigoCnj: { j: "5", tr: "19" },
    varas: trtVaras(19, ["AL"]),
    cidades: ["Maceió", "Arapiraca"],
  },
  {
    sigla: "TRT-20",
    nome: "TRT 20ª Região",
    tipo: "TRT",
    uf: "SE",
    codigoCnj: { j: "5", tr: "20" },
    varas: trtVaras(20, ["SE"]),
    cidades: ["Aracaju"],
  },
  {
    sigla: "TRT-21",
    nome: "TRT 21ª Região",
    tipo: "TRT",
    uf: "RN",
    codigoCnj: { j: "5", tr: "21" },
    varas: trtVaras(21, ["RN"]),
    cidades: ["Natal", "Mossoró"],
  },
  {
    sigla: "TRT-22",
    nome: "TRT 22ª Região",
    tipo: "TRT",
    uf: "PI",
    codigoCnj: { j: "5", tr: "22" },
    varas: trtVaras(22, ["PI"]),
    cidades: ["Teresina"],
  },
  {
    sigla: "TRT-23",
    nome: "TRT 23ª Região",
    tipo: "TRT",
    uf: "MT",
    codigoCnj: { j: "5", tr: "23" },
    varas: trtVaras(23, ["MT"]),
    cidades: ["Cuiabá", "Várzea Grande", "Rondonópolis"],
  },
  {
    sigla: "TRT-24",
    nome: "TRT 24ª Região",
    tipo: "TRT",
    uf: "MS",
    codigoCnj: { j: "5", tr: "24" },
    varas: trtVaras(24, ["MS"]),
    cidades: ["Campo Grande", "Dourados"],
  },

  // TRFs
  {
    sigla: "TRF-1",
    nome: "TRF 1ª Região",
    tipo: "TRF",
    codigoCnj: { j: "4", tr: "01" },
    varas: VARAS_FEDERAIS,
    cidades: ["Brasília", "Goiânia", "Belém", "Manaus"],
  },
  {
    sigla: "TRF-2",
    nome: "TRF 2ª Região",
    tipo: "TRF",
    codigoCnj: { j: "4", tr: "02" },
    varas: VARAS_FEDERAIS,
    cidades: ["Rio de Janeiro", "Vitória"],
  },
  {
    sigla: "TRF-3",
    nome: "TRF 3ª Região",
    tipo: "TRF",
    codigoCnj: { j: "4", tr: "03" },
    varas: VARAS_FEDERAIS,
    cidades: ["São Paulo", "Campinas"],
  },
  {
    sigla: "TRF-4",
    nome: "TRF 4ª Região",
    tipo: "TRF",
    codigoCnj: { j: "4", tr: "04" },
    varas: VARAS_FEDERAIS,
    cidades: ["Porto Alegre", "Curitiba", "Florianópolis"],
  },
  {
    sigla: "TRF-5",
    nome: "TRF 5ª Região",
    tipo: "TRF",
    codigoCnj: { j: "4", tr: "05" },
    varas: VARAS_FEDERAIS,
    cidades: ["Recife", "Fortaleza", "Salvador"],
  },
  {
    sigla: "TRF-6",
    nome: "TRF 6ª Região",
    tipo: "TRF",
    codigoCnj: { j: "4", tr: "06" },
    varas: VARAS_FEDERAIS,
    cidades: ["Belo Horizonte"],
  },

  // TJs (capitais principais)
  ...[
    "SP",
    "RJ",
    "MG",
    "RS",
    "BA",
    "PR",
    "SC",
    "PE",
    "CE",
    "GO",
    "DF",
    "ES",
    "PA",
    "MA",
    "PB",
    "RN",
    "MT",
    "MS",
    "AL",
    "SE",
    "PI",
    "RO",
    "AC",
    "AM",
    "AP",
    "RR",
    "TO",
  ].map((uf) => ({
    sigla: `TJ${uf}`,
    nome: `Tribunal de Justiça do ${uf}`,
    tipo: "TJ" as const,
    uf,
    codigoCnj: { j: "8", tr: String(UFS_CNJ.indexOf(uf) + 1).padStart(2, "0") },
    varas: VARAS_ESTADUAIS,
    cidades: [],
  })),
];

export const TIPOS_PERICIA = [
  "Perícia Contábil Judicial",
  "Perícia Contábil Extrajudicial",
  "Perícia Arbitral",
  "Perícia Trabalhista",
  "Perícia Financeira",
  "Perícia Bancária",
  "Perícia Tributária",
  "Perícia Societária",
  "Perícia de Apuração de Haveres",
  "Perícia de Prestação de Contas",
  "Perícia Empresarial",
  "Perícia Patrimonial",
  "Perícia em Contratos",
  "Perícia em Fraudes e Irregularidades",
  "Perícia em Recuperação Judicial",
  "Perícia em Falência",
  "Perícia em Dissolução de Sociedades",
  "Perícia em Liquidação de Sentença",
  "Perícia em Avaliação de Empresas",
  "Perícia em Cálculos Trabalhistas",
  "Perícia em Cálculos Previdenciários",
  "Perícia em Cálculos Tributários",
  "Perícia em Cálculos Financeiros",
  "Perícia em Lucros Cessantes",
  "Perícia em Indenizações e Danos Materiais",
  "Perícia em Inventário e Partilha",
  "Perícia em Contratos Bancários",
  "Perícia em Reorganização Societária",
  "Perícia em Dissolução Parcial de Sociedade",
  "Perícia Investigativa/Fraude Contábil",
];

export function buscarTribunalPorCodigoCnj(j: string, tr: string): Tribunal | undefined {
  return TRIBUNAIS.find((t) => t.codigoCnj?.j === j && t.codigoCnj?.tr === tr);
}
